import { useState, useEffect } from 'react';
import { formatLastUpdated } from '../utils/timeUtils';

/**
 * Custom hook that provides a live-updating relative time string
 * @param date The date to calculate relative time from
 * @returns A string showing the relative time that updates every second
 */
export const useRelativeTime = (date: Date | null): string => {
  const [, setCurrentTime] = useState(new Date());

  useEffect(() => {
    if (!date) return;

    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, [date]);

  return date ? formatLastUpdated(date) : '';
};